import React from 'react';

import {useI18n} from '@udemy/i18n';
import {
    CourseUnit,
    RecommendationsComponent,
    RecommendationsComponentProps,
} from '@udemy/react-discovery-units';

type RecommendationsProps = RecommendationsComponentProps & {
    showAddToCartInCard?: boolean;
    showAddToCartInQuickview?: boolean;
    isMobile: boolean;
};

export const Recommendations: React.FC<RecommendationsProps> = (props) => {
    const {gettext} = useI18n();
    const isMobile = props.isMobile;
    const {showAddToCartInCard, showAddToCartInQuickview = true} = props;

    const getUnitComponentAndProps = () => {
        return {
            component: CourseUnit,
            componentProps: {
                allowAddToCartSuccessModal: !showAddToCartInCard,
                fullWidth: isMobile,
                showPager: !isMobile,
                gridCols: isMobile ? 1 : showAddToCartInCard ? 4 : undefined,
                showAddToCartInCourseCard: !!showAddToCartInCard,
                showAddToCartInQuickview,
                renderExperimentalCourseCards: isMobile ? false : !!showAddToCartInCard,
                cartButtonTextGoToCart: showAddToCartInCard ? gettext('In your cart') : undefined,
                cartButtonDisableOnGoToCart: !!showAddToCartInCard,
                disableMobileAddToCartRedirect: true,
                layout: isMobile ? (showAddToCartInCard ? 'singlecol' : 'multirow') : 'singlerow',
            },
        };
    };

    return (
        <RecommendationsComponent
            unitPropsByType={{
                CourseUnit: {
                    allowAddToCartSuccessModal: !showAddToCartInCard,
                    fullWidth: isMobile,
                    showPager: !isMobile,
                    gridCols: isMobile ? 1 : showAddToCartInCard ? 4 : undefined,
                    showAddToCartInCourseCard: !!showAddToCartInCard,
                    showAddToCartInQuickview,
                    renderExperimentalCourseCards: isMobile ? false : !!showAddToCartInCard,
                    cartButtonTextGoToCart: showAddToCartInCard
                        ? gettext('In your cart')
                        : undefined,
                    cartButtonDisableOnGoToCart: !!showAddToCartInCard,
                    disableMobileAddToCartRedirect: true,
                    layout: isMobile
                        ? showAddToCartInCard
                            ? 'singlecol'
                            : 'multirow'
                        : 'singlerow',
                },
            }}
            {...{...props, getUnitComponentAndProps: getUnitComponentAndProps}}
        />
    );
};
